import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Ribbon from "@/components/Ribbon";
import About from "@/components/About";
import Session from "@/components/Session";
import SessionsPage from "@/components/SessionsPage";
import Watch from "@/components/Watch";
import Deck from "@/components/Deck";
import MakingSpace from "@/components/MakingSpace";
import Footer from "@/components/Footer";
import AdminList from "@/components/AdminList";

const Home = () => (
  <main className="bg-[#131110] text-[#F2EFE9]">
    <Nav />
    <Hero />
    <Ribbon />
    <About />
    <Session />
    <Watch />
    <Deck />
    <MakingSpace />
    <Footer />
  </main>
);

function App() {
  return (
    <BrowserRouter>
      <ReactLenis root options={{ lerp: 0.09, wheelMultiplier: 0.95 }}>
        <div className="grain" aria-hidden="true" />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sessions" element={<SessionsPage />} />
          <Route path="/the-list" element={<AdminList />} />
        </Routes>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#1E1A18",
              border: "1px solid rgba(212,154,54,0.25)",
              color: "#F2EFE9",
              fontFamily: "'Manrope', sans-serif",
            },
          }}
        />
      </ReactLenis>
    </BrowserRouter>
  );
}

export default App;
